/* ==========================================================================
   SearcherFli > Client > Product > Openjaw > Row > Calendar
   ========================================================================== */

/* Modules */
const { addStyle, addData } = require('@bluekiri/alexandria/helpers/dataHelpers');

const Calendar = require('@bluekiri/alexandria-contrib-components/components/calendar-rxjs/client/js');
const CalendarTemplate = require('@bluekiri/alexandria-contrib-components/components/calendar-rxjs/template');
/* eslint-disable */
const CalendarActions = require('@bluekiri/alexandria-contrib-components/components/calendar-rxjs/client/js/store/actions');
/* eslint-enable */

const { RANGE, SINGLE } = require('../../../../../calendar/constants');
const { ROUNDTRIP } = require('../../../../constants');

const configuration = require('../../../../../config');

/* Render calendar */
const renderCalendar = ({ calendar, product }, literals, context) => {
    /* Literals */
    const { calendarLabel = '' } = literals;

    return CalendarTemplate(
        addStyle(
            addData(
                {
                    config: {
                        mode: product.toLowerCase() === ROUNDTRIP ? RANGE : SINGLE
                    },
                    icon: 'calendar',
                    label: calendarLabel,
                    ...calendar
                },
                { type: configuration().type.calendar }
            ),
            ['searcher__item', 'searcher__item--large', 'is-active']
        ),
        context
    );
};

/* Init */
function initCalendar(instance, index) {
    const panel = instance;

    /* Reference */
    panel.rows[index].calendar = Calendar(
        `${instance.selector} [data-row='${index}'] [data-component='CalendarRxjs'][data-type='${
            configuration().type.calendar
        }']`
    );

    /* Reactions */
    panel.reactions = {
        ...instance.reactions,
        [`change-calendar-${index}`]: instance.rows[index].calendar.store.subscribe((_, action) => {
            if (action.type !== CalendarActions.types.CHANGE_VALUE) return;

            /* Dispatch */
            instance.actions.changeRow({ calendar: action.payload, index });
        })
    };

    /* Start */
    const { value } = instance.rows[index].calendar.store.select('calendar');

    /* Sync */
    instance.actions.setRow({ calendar: [value], index });
}

/* Destroy */
function destroyCalendar(instance, index) {
    const panel = instance;

    panel.rows[index].calendar.actions.destroy();

    delete panel.rows[index].calendar;

    panel.reactions[`change-calendar-${index}`].unsubscribe();
    delete panel.reactions[`change-calendar-${index}`];
}

/* Exports */
module.exports = {
    renderCalendar,
    initCalendar,
    destroyCalendar
};
